import { createServerFn } from "@tanstack/react-start";
import {
  getCookie,
  setCookie,
} from "@tanstack/react-start/server";
import { Effect, Schema } from "effect";

const storageKey = "vivus-theme-ui";

const ThemeSchema = Schema.Struct({
  preference: Schema.Literals([
    "light",
    "dark",
    "system",
  ]).pipe(
    Schema.withDecodingDefaultType(
      Effect.succeed("system" as const)
    ),
    Schema.withConstructorDefault(
      Effect.succeed("system" as const)
    )
  ),
  lastSystemTheme: Schema.optional(
    Schema.Literals(["light", "dark"])
  ),
});

type Theme = typeof ThemeSchema.Type;

export const getThemeServerFn = createServerFn().handler(
  async () => {
    const parsedCookie = Schema.decodeUnknownSync(
      ThemeSchema
    )(JSON.parse(getCookie(storageKey) || "{}"));

    return {
      preference: parsedCookie.preference,
      resolved:
        parsedCookie.preference === "dark" ||
        (parsedCookie.preference === "system" &&
          parsedCookie.lastSystemTheme === "dark")
          ? "dark"
          : "light",
    };
  }
);

export const setThemeServerFn = createServerFn({
  method: "POST",
})
  .validator((data: unknown): Theme => {
    return Schema.decodeUnknownSync(ThemeSchema)(data);
  })
  .handler(async ({ data }) => {
    setCookie(storageKey, JSON.stringify(data));
  });
